import React from "react";

const ButtonSwitch = ({ options, selectedOption, onClickFn }) => {
  return (
    <div className="unit-container">
      {options.map((opt) => {
        return (
          <button
            data-button-type={selectedOption === opt ? "outline" : "text-white"}
            sz="small"
            onClick={() => onClickFn(opt)}
          >
            {opt.name}
          </button>
        );
      })}
    </div>
  );
};

export default ButtonSwitch;
